
        require('./index.scss');
        'use strict';

var $ = window.$;
var _module = {
    init: function init() {
        var time = $('#time')[0] && $('#time')[0].innerText;
        var link = $('.author').find('a').attr('href');
        var img = $('.avatar');
        var logo = $('.vlogo');
        if (typeof link === 'string') {
            img.click(function () {
                window.open(link, '_blank');
            });
            logo.click(function () {
                window.open(link, '_blank');
            });
        }
        if (time && typeof time === 'string') {
            var newTime = time.replace(/\b(\d{2}:\d{2}):\d{2}/, '$1');
            $('#time')[0].innerText = newTime;
        }
    }
};
_module.init();;
    


// WEBPACK FOOTER //
// ./src/module/home-detail/author/index.js